import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, ArrowRight } from 'lucide-react';
import { contactInfo, navigation } from '../data';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-[#004e3a] text-stone-300 pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2 text-white">
              <Logo className="h-[80px] w-auto" />
            </Link>
            <p className="text-sm leading-relaxed">
              Professionel skovservice med fokus på kvalitet, sikkerhed og naturpleje. Vi løser opgaver for både private, erhverv og det offentlige.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={contactInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center transition-colors text-white"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-6">Vores ydelser</h3>
            <ul className="space-y-4">
              {navigation.find(n => n.name === 'Ydelser')?.children?.map((child) => (
                <li key={child.name}>
                  <Link to={child.href} className="text-sm hover:text-emerald-400 transition-colors flex items-center gap-2 group">
                    <ArrowRight className="w-3 h-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {child.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-6">Kontakt os</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-500 shrink-0" />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-emerald-500 shrink-0" />
                <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="text-sm hover:text-emerald-400 transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-emerald-500 shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm hover:text-emerald-400 transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="pt-2 text-xs text-stone-500">
                CVR: {contactInfo.cvr}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} TH Skovservice. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4">
            <a href="https://www.iubenda.com/privacy-policy/64817717" className="iubenda-white iubenda-noiframe iubenda-embed" title="Privatlivspolitik ">Privatlivspolitik</a>
            <a href="https://www.iubenda.com/privacy-policy/64817717/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed" title="Cookiepolitik ">Cookiepolitik</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
